import React, { useEffect, useRef, useState } from 'react';
import { navigate } from 'gatsby';
import { Modal, Buttons } from 'lidya-common-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import {
  availableLanguages,
  COMPONENTS,
  COUNTRY_LANGUAGE_LIST,
} from '../common/webSiteLanguages';
import './i18nModal.less';
import { useGlobalData } from '../../providers/globalDataProvider/globalDataProvider.useGlobalData';
import {
  getLocalLanguage,
  setLocalLanguage,
} from '../../providers/globalDataProvider/globalDataProvider.provider';
import LanguagePicker from '../common/languagePicker';
import { buildLink } from '../common/contextLink';

const I18nModalLimitedOperations = function ({ show, onClose }) {
  const countryLanguageList = {};
  Object.values(COUNTRY_LANGUAGE_LIST).filter((obj, key) => {
    if (obj.hasOperations === true) {
      const nObject = {
        ...obj,
        languages: [obj.languages[0]],
      };
      countryLanguageList[key] = nObject;
    }
  });

  const { country, language } = useGlobalData();
  const [startCountry] = useState(Object.values(countryLanguageList)[0].code);
  const [startLanguage] = useState(
    Object.values(countryLanguageList)[0].languages[0].code,
  );
  const { t } = useTranslation();
  const refPath = useRef(window.location.pathname);
  const refCountry = useRef(country);
  const refLanguage = useRef(language);

  useEffect(() => {
    refPath.current = window.location.pathname;
    setLocalLanguage({
      country: startCountry,
      language: startLanguage,
    });
  }, [startCountry, startLanguage]);

  const btns = [
    {
      label: t('web.modal.language.limited.cancel.label'),
      onClick: () => {
        const { current: currentPath } = refPath;
        const { current: currentCountry } = refCountry;
        const { current: currentLanguage } = refLanguage;
        setLocalLanguage({
          country: currentCountry,
          language: currentLanguage,
        });
        navigate(currentPath);
        onClose();
      },
      type: Buttons.BUTTON_TYPES.TERTIARY,
    },
    {
      label: t('web.modal.language.limited.submit.label'),
      onClick: () => {
        const { country: localCountry, language: localLanguage } = getLocalLanguage();

        const countryConfigs = availableLanguages.find(
          (c) => c.country === localCountry,
        ) || { links: [] };
        const linkConfigs = countryConfigs.links.find(
          (config) => config.component === COMPONENTS.HOME,
        );
        const slug = linkConfigs[`slug_${localLanguage}`];
        const link = buildLink({
          pathname: slug,
          country: localCountry,
          language: localLanguage,
        });
        navigate(link);
        onClose();
      },
      type: Buttons.BUTTON_TYPES.PRIMARY,
    },
  ];

  return (
    <Modal
      show={show}
      close={btns[0].onClick}
      closeOnTop={false}
      medium
      title={t('web.modal.language.limited.selector.label')}
      buttons={btns}
      className="m-i18nModal__modal"
      bodyClass="m-i18nModal__modalBody"
    >
      <LanguagePicker
        // country={startCountry}
        // language={startLanguage}
        className="m-i18nModal__languagePicker"
        showLabels
        inlineLanguage={false}
        countryLanguageList={countryLanguageList}
        compactMode
      />
    </Modal>
  );
};

export default I18nModalLimitedOperations;
